import moment from "moment";

import { OnSchedHelpers }       from "../../utils/OnSchedHelpers";
import { OnSchedWizardHelpers } from "../../utils/WizardHelpers/OnSchedWizardHelpers";
import { OnSchedTemplates }     from "../../OnSchedTemplates";


export const AvailableTimes = (element, response, dayClicked) => {
  // TODO: any response error needs to be displayed and captured if not recoverable
  if (response.error) {
      OnSchedHelpers.ThrowError(element, response);
      return;
  }
  
  var elAvailableTimes = document.getElementById('onsched-available-times-col');
  elAvailableTimes && elAvailableTimes.classList.contains('loading') ? elAvailableTimes.classList.remove('loading') : null;
  
  if (element.options.loadTimesOnMount) {
    var elTimesContainer = document.getElementById('available-times-row');
      elTimesContainer.classList.add('display-times');
  }

  // I need to update the calendar html from the availbleDays info in the response
  // I need to use the FirstAvailableDate in the response if is returned
  var selectedDate = response.firstAvailableDate.length > 0 ?
      OnSchedHelpers.ParseDate(response.firstAvailableDate) :
      OnSchedHelpers.ParseDate(response.startDate);

  if (response.calendarDaySelected) {
    selectedDate = OnSchedHelpers.ParseDate(response.calendarDaySelected);
  }
  else {
    // Only reload timezones if loading availability
    OnSchedWizardHelpers.InitTimezoneSelect(element, {}, response, dayClicked);
  }

  const today = new Date().toISOString().slice(0, 10);

  if (element.params.date) {
    selectedDate = OnSchedHelpers.ParseDate(element.params.date);
  }

  if (element.params.minDate) {
    selectedDate = OnSchedHelpers.ParseDate(element.params.minDate);
  }

  if (dayClicked) {
    selectedDate = OnSchedHelpers.ParseDate(dayClicked);
  }

  var rebuildCalendar = response.availableDays.length > 0;
  if (rebuildCalendar) {
      // Helper function to get the number of displayable calendar days
      var days = OnSchedHelpers.GetCalendarDays(selectedDate);
      // We only take the number of availableDays that we need to populate the calendar, hence the slice.
      var availableDays = response.availableDays.length > days ? response.availableDays.slice(0, days) : response.availableDays;
      var elCalendar = document.querySelector(".onsched-calendar");

      // if (element.params.fullAvailabilityDays) {
      //   // close days that have no times available
      //   const daysWithAvailability = [...new Set(response.availableTimes.map(t => t.date))];
      //   const todaysIndex = availableDays.indexOf(availableDays.filter(a => a.date === today)[0]);
      //   const todaysDate = parseInt(today.slice(-2));
      //   const daysLeftInMonth = moment().endOf('month').diff(moment(), 'days');

      //   const maxDates = (element.params.fullAvailabilityDays + todaysIndex) < daysLeftInMonth + todaysDate ? (element.params.fullAvailabilityDays + todaysIndex) : daysLeftInMonth + todaysDate
        
      //   for (var i = todaysIndex > 0 ? todaysIndex : 0;i < maxDates;i++) {
      //     if (!daysWithAvailability.includes(availableDays[i].date)) {
      //       availableDays[i].available = false;
      //       availableDays[i].reasonCode = 1001
      //       availableDays[i].reason = 'No available times'
      //     }
      //   }
      // }

      if (element.params.maxDate) {
        // If Max Days param is present, filter out days beyond
        availableDays = availableDays.map(d => {
          let newDay = d;

          if (moment(d.date).isAfter(element.params.maxDate)) {
            newDay.available = false;
            newDay.reason = "Max date restriction";
            newDay.reasonCode = 501;
          }

          return newDay;
        })
      }

      if (element.params.minDate) {
        // If Max Days param is present, filter out days beyond
        availableDays = availableDays.map(d => {
          let newDay = d;

          if (moment(d.date).isBefore(element.params.minDate)) {
            newDay.available = false;
            newDay.reason = "Min date restriction";
            newDay.reasonCode = 501;
          }

          return newDay;
        })
      }
      
      elCalendar.innerHTML = OnSchedTemplates.calendarSelector(availableDays, selectedDate, element.onsched.locale);
   }

  var elServiceName = document.querySelector(".onsched-calendar-header .onsched-service-name");
  elServiceName.innerHTML = `<i class="fas fa-clock"></i>${OnSchedHelpers.FormatDuration(response.serviceDuration)} ${response.serviceName}`;

  var resourceName = response.resourceName;
  if (!OnSchedHelpers.IsEmpty(resourceName))
      elServiceName.innerHTML += ` with ${resourceName}`

  // Find todays date and add class
  var elToday = document.querySelector(`[data-date="${today}"]`);
  elToday ? elToday.classList.add('today'): null;

  // Populate the available times list
  var htmlTimes = OnSchedTemplates.availableTimes2(element, response, selectedDate);
  var elTimes = document.querySelector(".onsched-available-times");
  elTimes.innerHTML = htmlTimes;

  OnSchedHelpers.HideProgress();
  OnSchedHelpers.UtilityCustomEvents.ElementLoaded(element);
}
